import type { ChipProps } from '@mui/material/Chip';

export type ModeVisual = {
  chipColor: ChipProps['color'];
  accentColor?: string | null;
};

const MODE_FAMILIES: Record<string, ModeVisual> = {
  shutdown: { chipColor: 'default', accentColor: null },
  standby: { chipColor: 'warning', accentColor: null },
  failure: { chipColor: 'error', accentColor: null },
  cooling: { chipColor: 'success', accentColor: null },
  refrigeration: { chipColor: 'info', accentColor: null },
  recirculating: { chipColor: 'secondary', accentColor: '#6A1B9A' },
  heating: { chipColor: 'default', accentColor: null },
  cure: { chipColor: 'default', accentColor: null }
};

const MODE_TO_FAMILY: Record<string, keyof typeof MODE_FAMILIES> = {
  'shutdown': 'shutdown',
  'fan switch off': 'shutdown',
  'fan remote off': 'standby',
  'failure': 'failure',
  'standby': 'standby',
  'remote standby': 'standby',
  'refrig remote off': 'standby',
  'refrigeration remote off': 'standby',
  'remote off': 'standby',
  'cooling': 'cooling',
  'cooling (ramping)': 'cooling',
  'cooling (dehumidify)': 'cooling',
  'cooling (dehumid)': 'cooling',
  'purging co2': 'cooling',
  'co2 purge': 'cooling',
  'recirculating': 'recirculating',
  'recirculation': 'recirculating',
  'fan manual': 'recirculating',
  'fan boost': 'recirculating',
  'refrigeration': 'refrigeration',
  'refrigeration (ramping)': 'refrigeration',
  'refrig (dehumidify)': 'refrigeration',
  'refrig (dehumid)': 'refrigeration',
  'defrosting': 'refrigeration',
  'heating': 'heating',
  'heating (ramping)': 'heating',
  'cure': 'cure'
};

export const getModeVisual = (mode: string | null | undefined): ModeVisual => {
  if (!mode) return MODE_FAMILIES.shutdown;
  const normalized = mode.trim().toLowerCase();
  const familyKey = MODE_TO_FAMILY[normalized];
  return familyKey ? MODE_FAMILIES[familyKey] : MODE_FAMILIES.shutdown;
};

export const ModeVisuals = {
  MODE_FAMILIES,
  MODE_TO_FAMILY,
  getModeVisual
};
